function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { getEditorPointerUniqueId } from '../getEditorPointerUniqueId';
const REGULAR_STATE = 'regular';
export function groupByEditorPointer(runtimeManifestContext, manifestEntity) {
  const groups = {};
  Object.keys(runtimeManifestContext.tree.mappings[manifestEntity]).forEach(key => {
    var _runtimeManifestConte;
    const config = runtimeManifestContext.tree.mappings[manifestEntity][key][0];

    /**
     * ignore keys that do not exist in manifest itself,
     * related to CSS expand feature e.g., border -> borderWidth -> borderColor etc.
     */

    if (
    // @ts-expect-error xxx
    !((_runtimeManifestConte = runtimeManifestContext.tree.manifest.editorElement) != null && (_runtimeManifestConte = _runtimeManifestConte[manifestEntity]) != null && _runtimeManifestConte[config.key])) {
      return;
    }
    const idx = `${getEditorPointerUniqueId(config.editorPointer)}_${config.editorPointer}`;
    if (!groups[idx]) {
      groups[idx] = {
        editorPointer: config.editorPointer,
        extensionType: config.extensionType,
        items: []
      };
    }
    groups[idx].items.push({
      runtimeKey: key,
      originalKey: config.key
    });
  });
  return Object.values(groups);
}
var _ManifestResolver_brand = /*#__PURE__*/new WeakSet();
export class ManifestResolver {
  constructor(api, runtimeManifestContext) {
    this.api = api;
    this.runtimeManifestContext = runtimeManifestContext;
    _classPrivateMethodInitSpec(this, _ManifestResolver_brand);
  }
  getOriginalManifests() {
    return this.runtimeManifestContext.manifests.map(_ref => {
      let {
        store,
        editorPointer
      } = _ref;
      return {
        manifest: store.manifest,
        editorPointer
      };
    });
  }
  getRuntimeIdentifiers() {
    /**
     * this is probably not the correct way to
     * get editorPointer & extensionType for filtering,
     * but in 99.999% it will work now
     */

    const extensionType = this.runtimeManifestContext.manifests[0].store.extensionType;
    const editorPointer = this.runtimeManifestContext.manifests[0].editorPointer;
    return {
      extensionType,
      editorPointer
    };
  }
  getChildren() {
    const extensionType = this.runtimeManifestContext.manifests[0].store.extensionType;
    const {
      tree
    } = this.runtimeManifestContext;
    return tree.children.filter(childContext => {
      var _childContext$editorP;
      const path = (_childContext$editorP = childContext.editorPointer) == null ? void 0 : _childContext$editorP.innerElementPath;
      if (!(path != null && path.length)) {
        return false;
      }
      const key = path[path.length - 1];

      /**
       * TODO: verify if we can use root extension type here
       */
      return _assertClassBrand(_ManifestResolver_brand, this, _isVisibleByDisplayFilters).call(this, key, 'elements', {
        preset: this.api.presets.getAppliedPreset(childContext.editorPointer, extensionType),
        state: this.api.state.getState(childContext.editorPointer, extensionType)
      });
    });
  }
  getStyleDefinitions() {
    return {
      cssProperties: _assertClassBrand(_ManifestResolver_brand, this, _getCssPropertiesDefinitions).call(this),
      cssCustomProperties: _assertClassBrand(_ManifestResolver_brand, this, _getCssCustomPropertiesDefinitions).call(this)
    };
  }
  getDataDefinitions() {
    var _this$runtimeManifest;
    const keys = _assertClassBrand(_ManifestResolver_brand, this, _getMappedManifestEntityKeys).call(this, 'data');
    const filteredItemsByDisplayFilters = _assertClassBrand(_ManifestResolver_brand, this, _filterItemsByDisplayFilters).call(this, keys, 'data');
    const filteredItemsByState = _assertClassBrand(_ManifestResolver_brand, this, _filterItemsByState).call(this, filteredItemsByDisplayFilters);
    return _assertClassBrand(_ManifestResolver_brand, this, _buildObject).call(this, filteredItemsByState, ((_this$runtimeManifest = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest.data) ?? {});
  }
  getCustomActionDefinitions() {
    var _this$runtimeManifest2;
    const keys = _assertClassBrand(_ManifestResolver_brand, this, _getMappedManifestEntityKeys).call(this, 'customActions');
    const filteredItemsByDisplayFilters = _assertClassBrand(_ManifestResolver_brand, this, _filterItemsByDisplayFilters).call(this, keys, 'customActions');
    return _assertClassBrand(_ManifestResolver_brand, this, _buildObject).call(this, filteredItemsByDisplayFilters, ((_this$runtimeManifest2 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest2.customActions) ?? {});
  }
  getActionDefinitions() {
    var _this$runtimeManifest3;
    const keys = _assertClassBrand(_ManifestResolver_brand, this, _getMappedManifestEntityKeys).call(this, 'actions');
    const filteredItems = _assertClassBrand(_ManifestResolver_brand, this, _filterItemsByDisplayFilters).call(this, keys, 'actions');
    return _assertClassBrand(_ManifestResolver_brand, this, _buildObject).call(this, filteredItems,
    // @ts-expect-error xxx
    ((_this$runtimeManifest3 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest3.actions) ?? {});
  }
  getStateDefinitions() {
    var _this$runtimeManifest4;
    const keys = _assertClassBrand(_ManifestResolver_brand, this, _getMappedManifestEntityKeys).call(this, 'states');
    const viewStates = this.runtimeManifestContext.manifests.map(_ref2 => {
      let {
        editorPointer,
        store
      } = _ref2;
      return this.api.state.getViewStates(editorPointer, store.extensionType);
    });
    return {
      ..._assertClassBrand(_ManifestResolver_brand, this, _buildObject).call(this, keys, ((_this$runtimeManifest4 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest4.states) ?? {}),
      ...viewStates.reduce((acc, x) => ({
        ...acc,
        ...x
      }), {})
    };
  }
  getPresetDefinitions() {
    var _this$runtimeManifest5, _this$runtimeManifest6;
    const editorPointer = this.runtimeManifestContext.manifests[0].editorPointer;
    if (!editorPointer) {
      return {};
    }
    const presets = ((_this$runtimeManifest5 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest5.presets) ?? {};
    const keys = _assertClassBrand(_ManifestResolver_brand, this, _getMappedManifestEntityKeys).call(this, 'presets');
    const currentBreakpoint = this.api.stage.getBreakpointFromPointer(editorPointer);
    const filteredItems = _assertClassBrand(_ManifestResolver_brand, this, _filterPresetsByBreakpoint).call(this, keys, presets, currentBreakpoint);
    return _assertClassBrand(_ManifestResolver_brand, this, _buildObject).call(this, filteredItems, ((_this$runtimeManifest6 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest6.presets) ?? {});
  }
  getLayoutDefinitions() {
    var _this$runtimeManifest7, _presets$appliedPrese, _this$runtimeManifest9;
    const {
      editorPointer,
      extensionType
    } = this.getRuntimeIdentifiers();
    const presets = (_this$runtimeManifest7 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest7.presets;
    const appliedPreset = this.api.presets.getAppliedPreset(editorPointer, extensionType);
    if (!appliedPreset) {
      var _this$runtimeManifest8;
      return ((_this$runtimeManifest8 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest8.layout) ?? {};
    }
    return (presets == null || (_presets$appliedPrese = presets[appliedPreset]) == null || (_presets$appliedPrese = _presets$appliedPrese.presetDefaults) == null ? void 0 : _presets$appliedPrese.layout) || ((_this$runtimeManifest9 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest9.layout) || {};
  }
  getDisplayGroupDefinitions(options) {
    var _this$runtimeManifest0, _options$filter;
    const displayGroups = (_this$runtimeManifest0 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest0.displayGroups;
    if (!displayGroups) {
      return {};
    }
    const groupTypeFilter = options == null || (_options$filter = options.filter) == null ? void 0 : _options$filter.groupType;
    if (!groupTypeFilter) {
      return displayGroups;
    }
    return Object.fromEntries(Object.entries(displayGroups).filter(_ref3 => {
      let [_groupKey, displayGroup] = _ref3;
      return displayGroup.groupType === groupTypeFilter;
    }));
  }
  applyDisplayFilters(items, filterType) {
    const {
      editorPointer,
      extensionType
    } = this.getRuntimeIdentifiers();
    const state = this.api.state.getState(editorPointer, extensionType);
    const preset = this.api.presets.getAppliedPreset(editorPointer, extensionType);
    const mappedKeys = Object.keys(items).map(key => {
      return {
        runtimeKey: key,
        originalKey: key,
        state,
        preset,
        editorPointer,
        extensionType
      };
    });
    const filteredItems = _assertClassBrand(_ManifestResolver_brand, this, _filterItemsByDisplayFilters).call(this, mappedKeys, filterType);
    return _assertClassBrand(_ManifestResolver_brand, this, _buildObject).call(this, filteredItems, items);
  }
}
function _getCssPropertiesDefinitions() {
  var _this$runtimeManifest1;
  const keys = _assertClassBrand(_ManifestResolver_brand, this, _getMappedManifestEntityKeys).call(this, 'cssProperties');
  const filteredItemsByDisplayFilters = _assertClassBrand(_ManifestResolver_brand, this, _filterItemsByDisplayFilters).call(this, keys, 'cssProperties');
  const filteredItemsByState = _assertClassBrand(_ManifestResolver_brand, this, _filterItemsByState).call(this, filteredItemsByDisplayFilters);
  return _assertClassBrand(_ManifestResolver_brand, this, _buildObject).call(this, filteredItemsByState, ((_this$runtimeManifest1 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest1.cssProperties) ?? {});
}
function _getCssCustomPropertiesDefinitions() {
  var _this$runtimeManifest10;
  const keys = _assertClassBrand(_ManifestResolver_brand, this, _getMappedManifestEntityKeys).call(this, 'cssCustomProperties');
  const filteredItemsByDisplayFilters = _assertClassBrand(_ManifestResolver_brand, this, _filterItemsByDisplayFilters).call(this, keys, 'cssCustomProperties');
  const filteredItemsByState = _assertClassBrand(_ManifestResolver_brand, this, _filterItemsByState).call(this, filteredItemsByDisplayFilters);
  return _assertClassBrand(_ManifestResolver_brand, this, _buildObject).call(this, filteredItemsByState, ((_this$runtimeManifest10 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest10.cssCustomProperties) ?? {});
}
function _filterPresetsByBreakpoint(items, presets, currentBreakpoint) {
  if (!currentBreakpoint) {
    return items;
  }
  return items.filter(_ref4 => {
    let {
      runtimeKey
    } = _ref4;
    const preset = presets[runtimeKey];
    if (!preset) {
      return false;
    }
    return !preset.optimizedFor || preset.optimizedFor.length === 0 || preset.optimizedFor.includes(currentBreakpoint);
  });
}
function _buildObject(items, data) {
  return items.reduce((acc, _ref5) => {
    let {
      runtimeKey
    } = _ref5;
    return {
      ...acc,
      [runtimeKey]: data[runtimeKey]
    };
  }, {});
}
function _getMappedManifestEntityKeys(manifestEntity) {
  return groupByEditorPointer(this.runtimeManifestContext, manifestEntity).flatMap(_ref6 => {
    let {
      extensionType,
      editorPointer,
      items
    } = _ref6;
    const state = this.api.state.getState(editorPointer, extensionType);
    const preset = this.api.presets.getAppliedPreset(editorPointer, extensionType);
    return items.map(_ref7 => {
      let {
        runtimeKey,
        originalKey
      } = _ref7;
      return {
        extensionType,
        editorPointer,
        state: state ? state : REGULAR_STATE,
        preset,
        runtimeKey,
        originalKey
      };
    });
  });
}
function _filterItemsByDisplayFilters(items, filterType) {
  return items.filter(_ref8 => {
    let {
      preset,
      state,
      originalKey
    } = _ref8;
    return _assertClassBrand(_ManifestResolver_brand, this, _isVisibleByDisplayFilters).call(this, originalKey, filterType, {
      preset,
      state
    });
  });
}
function _isVisibleByDisplayFilters(key, filterType, context) {
  var _root$editorElement, _this$runtimeManifest11, _this$runtimeManifest12;
  const root = this.runtimeManifestContext.tree.manifest;
  const rootDisplayFilters = (_root$editorElement = root.editorElement) == null ? void 0 : _root$editorElement.displayFilters;
  const rootDisplayFilter = rootDisplayFilters == null ? void 0 : rootDisplayFilters[filterType];
  const presets = (_this$runtimeManifest11 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest11.presets;
  const states = (_this$runtimeManifest12 = this.runtimeManifestContext.tree.manifest.editorElement) == null ? void 0 : _this$runtimeManifest12.states;
  const isItemVisible = (_key, displayFilter) => {
    var _displayFilter$show, _displayFilter$hide;
    if (!displayFilter) {
      return true;
    }
    if ((_displayFilter$show = displayFilter.show) != null && _displayFilter$show.length) {
      return displayFilter.show.includes(_key);
    }
    if ((_displayFilter$hide = displayFilter.hide) != null && _displayFilter$hide.length) {
      return !displayFilter.hide.includes(_key);
    }
    return true;
  };
  if (!isItemVisible(key, rootDisplayFilter)) {
    return false;
  }
  if (context.preset) {
    var _presets$context$pres;
    const presetDisplayFilters = presets == null || (_presets$context$pres = presets[context.preset]) == null || (_presets$context$pres = _presets$context$pres.presetDefaults) == null ? void 0 : _presets$context$pres.displayFilters;
    if (!isItemVisible(key, presetDisplayFilters == null ? void 0 : presetDisplayFilters[filterType])) {
      return false;
    }
  }
  if (context.state) {
    var _states$context$state;
    const stateDisplayFilters = states == null || (_states$context$state = states[context.state]) == null ? void 0 : _states$context$state.displayFilters;
    return isItemVisible(key, stateDisplayFilters == null ? void 0 : stateDisplayFilters[filterType]);
  }
  return true;
}
function _filterItemsByState(items) {
  return items;
  // TODO: uncomment as soon as there types item.state types in the manifest
  // return items.filter(({ item, state }) => {
  //   if (!item.states || item.states.length === 0) {
  //     return true;
  //   } else {
  //     return item.states.includes(state);
  //   }
  // });
}
//# sourceMappingURL=ManifestResolver.js.map